/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:2de15c0f-7242-464f-b3ff-a3bd5902bfab",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_kIpzGZ0ic",
    "aws_user_pools_web_client_id": "44ssclvmv6hdgie4r9aqhcd64o",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://dqtdpgv7qrft3pknn7gp5fi6iu.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-t562mtn6xfcwxpe7huzmxxm2qq",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://9sd2c6803m.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_mobile_analytics_app_id": "1e919964754144528e66914f1478ae1a",
    "aws_mobile_analytics_app_region": "us-east-1"
};


export default awsmobile;
